import Button from "../button/Button";
import Banner from "../Banner";
import { motion } from "framer-motion";
import { Capitalize } from "../../utils";
import { Loader } from "../loader/Loader";
import clsx from "clsx";

function PreGameUI({ onclick, loading, game }) {
  return (
    <div>
      <Banner game={game} />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 3, delay: 0.4 }}
        className="bg-white rounded-[20px] -mt-10 py-3 px-2"
      >
        <div
          className={clsx(
            game?.name?.includes("PIF") && "!border-[#43a9a8]",
            "border-4 border-primary-main rounded-[20px] pt-3 pb-6 px-3",
          )}
        >
          <h3 className="text-xl font-medium mb-2">Rules</h3>
          <ol className="my-4 list-decimal px-6">
            {game?.rules?.map((x) => {
              return (
                <li key={x.id}>
                  <p className="text-black mt-3 px-1 font-medium">
                    {Capitalize(x.rule_description)}
                  </p>
                </li>
              );
            })}
          </ol>
          <div className="mt-10 px-8">
            <Button
              className={clsx(
                game?.name?.includes("PIF") && "custom-gradients",
                "animate-breathing",
              )}
              onClick={() => {
                if (game?.spin_the_wheels?.length > 0) {
                  onclick(game?.spin_the_wheels[0]?.id);
                } else {
                  onclick();
                }
              }}
              text={
                loading ? (
                  <Loader width="24px" height="24px" type="bubbles" />
                ) : (
                  "Start Game"
                )
              }
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default PreGameUI;
